export const WORKFLOW_STANDARD_PAYIN = "standard_payin";
export const WORKFLOW_STANDARD_PAYOUT = "standard_payout";
export const WORKFLOW_EXTERNAL_PAYOUT = "external_payout";
export const WORKFLOW_EXCHANGE_BUY = "exchange_buy";
export const WORKFLOW_EXCHANGE_SELL = "exchange_sell";

type WorkflowKind =
    | typeof WORKFLOW_STANDARD_PAYIN
    | typeof WORKFLOW_STANDARD_PAYOUT
    | typeof WORKFLOW_EXTERNAL_PAYOUT
    | typeof WORKFLOW_EXCHANGE_BUY
    | typeof WORKFLOW_EXCHANGE_SELL;

export type WorkflowModuleName = "standard_payin" | "standard_payout" | "external_payout" | "exchange_buy" | "exchange_sell" | "unsupported";
export type WorkflowDirection = "payin" | "payout";

export interface WorkflowDescriptor {
    module: Exclude<WorkflowModuleName, "unsupported">;
    direction: WorkflowDirection;
    external: boolean;
}

const workflowDescriptors: Record<WorkflowKind, WorkflowDescriptor> = {
    [WORKFLOW_STANDARD_PAYIN]: {module: "standard_payin", direction: "payin", external: false},
    [WORKFLOW_STANDARD_PAYOUT]: {module: "standard_payout", direction: "payout", external: false},
    [WORKFLOW_EXTERNAL_PAYOUT]: {module: "external_payout", direction: "payout", external: true},
    [WORKFLOW_EXCHANGE_BUY]: {module: "exchange_buy", direction: "payin", external: false},
    [WORKFLOW_EXCHANGE_SELL]: {module: "exchange_sell", direction: "payout", external: false},
};

export function resolveWorkflowDescriptor(workflowKind: string): WorkflowDescriptor | null {
    if (!Object.prototype.hasOwnProperty.call(workflowDescriptors, workflowKind)) return null;
    return workflowDescriptors[workflowKind as WorkflowKind];
}

export function isSupportedWorkflow(workflowKind: string): boolean {
    return resolveWorkflowDescriptor(workflowKind) != null;
}

export function isPayinWorkflow(workflowKind: string): boolean {
    return resolveWorkflowDescriptor(workflowKind)?.direction === "payin";
}

export function isExternalWorkflow(workflowKind: string): boolean {
    return resolveWorkflowDescriptor(workflowKind)?.external === true;
}

export function resolveWorkflowModule(workflowKind: string): WorkflowModuleName {
    return resolveWorkflowDescriptor(workflowKind)?.module ?? "unsupported";
}
